"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.naverPayClaim = void 0;
var utils_1 = require("../../utils");
exports.naverPayClaim = function (axios) {
    return {
        putClaimsNoNaverPayReturnsApprove: function (request) {
            var url = utils_1.paramPathchange('/claims/{no}/naver-pay/returns/approve', request);
            return axios.put(url, request.data);
        },
        putClaimsNoNaverPayReturnsWithhold: function (request) {
            var url = utils_1.paramPathchange('/claims/{no}/naver-pay/returns/withhold', request);
            return axios.put(url, request.data);
        },
        putClaimsNoNaverPayReturnsReleaseHold: function (request) {
            var url = utils_1.paramPathchange('/claims/{no}/naver-pay/returns/release-hold', request);
            return axios.put(url, request.data);
        },
        putClaimsNoNaverPayExchangesReleaseHold: function (request) {
            var url = utils_1.paramPathchange('/claims/{no}/naver-pay/exchanges/release-hold', request);
            return axios.put(url, request.data);
        },
        putClaimsNoNaverPayExchangeWithhold: function (request) {
            var url = utils_1.paramPathchange('/claims/{no}/naver-pay/exchanges/withhold', request);
            return axios.put(url, request.data);
        }
    };
};
